/** Saturn ottomans use bed textile + legs. Match slug_en (e.g. saturn-2017), not only exact title "saturn". */
export function isSaturnOttoman(ottoman: any): boolean {
  if (!ottoman) return false
  const hay = [ottoman.name, ottoman.title, ottoman.slug, ottoman.slug_en, ottoman.slugEn]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()
  return hay.includes('saturn')
}
